import React from 'react';
import styled from '@emotion/styled';

import { isNonEmptyString } from '~/src/common';

function isValidImageUrl(url: string) {
  return isNonEmptyString(url);
}

const Contaner = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Backdrop = styled.div`
  background: black;
  opacity: 0.4;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
export const BackgroundImage: React.FC<{ url: string }> = ({ url }) => {
  if (!isValidImageUrl(url)) {
    return null;
  }
  return (
    <Contaner>
      <Backdrop />
      <img alt="media cover" role="presentation" src={url} />
    </Contaner>
  );
};
